export default "__VITE_ASSET__70f66292__"